// AWS Configuration for S3 Storage Browser (Amplify v6) - Storage Only
export const awsConfig = {
  Storage: {
    S3: {
      bucket: 'dump-manager-test',
      region: 'ap-northeast-2'
    }
  }
};

// Environment variables (for production)
export const getAwsConfig = () => {
  const region = process.env.REACT_APP_AWS_REGION || 'ap-northeast-2';
  const s3Bucket = process.env.REACT_APP_S3_BUCKET || 'dump-manager-test';

  return {
    Storage: {
      S3: {
        bucket: s3Bucket,
        region: region
      }
    }
  };
};

// AWS 자격 증명을 위한 임시 설정 (퍼블릭 읽기 전용)
export const getPublicAwsConfig = () => {
  return {
    Storage: {
      S3: {
        bucket: 'dump-manager-test',
        region: 'ap-northeast-2'
      }
    }
  };
};
